module.exports = __webpack_public_path__ + "img/1104.68c134c1.png";